import { useAtom } from "jotai";
import { MobileAppBannerStore } from "../stores/mobile-app-banner-store";

export function useMobileAppBannerStore() {
  const [{ isVisible }, setMobileAppBannerStore] = useAtom(MobileAppBannerStore);

  return { isVisible, setBannerIsVisible, setBannerIsNotVisible };

  function setBannerIsVisible() {
    setMobileAppBannerStore({ isVisible: true });
  }

  function setBannerIsNotVisible() {
    setMobileAppBannerStore({ isVisible: false });
  }
}
